import { Button, Icon, Modal } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

const dictPrefix = 'studentsDegreeStudent';

interface DeleteRenditionModalProps {
  toggleModal: () => void;
  deleteRendition: () => void;
  loading: boolean;
}
export const DeleteRenditionModal = ({
  toggleModal,
  deleteRendition,
  loading,
}: DeleteRenditionModalProps) => {
  const { t } = useTranslation();
  const texts = useMemo(
    () => ({
      title: t(`${dictPrefix}.tableRenditions.deleteModal.title`),
      subtitle: t(`${dictPrefix}.tableRenditions.deleteModal.subtitle`),
      delete: t(`${dictPrefix}.tableRenditions.deleteModal.delete`),
      cancel: t(`${dictPrefix}.tableRenditions.deleteModal.cancel`),
    }),
    [t],
  );
  return (
    <Modal
      isOpen
      toggle={toggleModal}
      size="lg"
      closeOnBackdrop={false}
      unmountOnClose
    >
      <Row className="justify-content-center">
        <Col xs="auto">
          <Icon name="warning" size="60" />
        </Col>
      </Row>
      <p className="text-dark fs-22 mt-3 mb-4 text-center">{texts.title}</p>
      <div className="text-dark fs-16 mt-3 text-center">{texts.subtitle}</div>
      <Row className="pt-5">
        <Col xs={12} md={6}>
          <Button
            outlined
            text={texts.cancel}
            onClick={toggleModal}
            disabled={loading}
            fullwidth
          />
        </Col>
        <Col xs={12} md={6}>
          <Button
            text={texts.delete}
            onClick={() => deleteRendition()}
            loading={loading}
            fullwidth
          />
        </Col>
      </Row>
    </Modal>
  );
};
